import * as React from "react";
import RedeemInitialView from "./RedeemInitialView";
import Model from "hooks/Model";

function RedeemScreen() {
  React.useEffect(() => {
    Model.setData("layoutConfig", { withBg: true });
  }, []);
  return <RedeemInitialView />;
}

export default RedeemScreen;
